import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type {
	MoveIssuesBetweenVersionsProps,
	MoveIssuesBetweenVersions as MoveIssuesBetweenVersionsType,
} from './ui/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const MoveVersions = lazy<typeof MoveIssuesBetweenVersionsType>(() =>
	import(/* webpackChunkName: "async-move-issues-between-versions" */ './ui/index.tsx').then(
		(mod) => mod.MoveIssuesBetweenVersions,
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ renderTrigger, ...props }: MoveIssuesBetweenVersionsProps) => (
	<JSErrorBoundary
		id="async.jira.move.issues.between.versions"
		packageName="jira-software-releases-move-issues-between-versions"
		teamName="fusion-solaris"
	>
		<Placeholder
			name="move-issues-between-versions"
			fallback={renderTrigger({
				triggerProps: {},
				isLoading: true,
				isSelected: false,
			})}
		>
			<MoveVersions renderTrigger={renderTrigger} {...props} />
		</Placeholder>
	</JSErrorBoundary>
);
